export default __webpack_public_path__ + "static/media/icon-dropdown-dark.3dcd1699.svg";